export const course_sub_menu = [
    { name: "Graduate Diploma of Management", sub_route: "/courses/graduate-diploma-of-management" },
    { name: "Advanced Diploma of Banking Services", sub_route: "/courses/advanced-diploma-of-banking" },
    { name: "Apply Online", sub_route: "/courses/online-application" },
  ];